import React, { useEffect, useState } from "react";

import BuildFormInputTypes from "./BuildFormInputTypes";

const TemplateFieldsField = ({ field, form, childConfig, assetTypeLength }) => {
  
  console.log('childConfig' , childConfig)
  const { id } = field;
  return (
    <div key={`${id}`} style={{ margin: "10px 5px" }}>
      <BuildFormInputTypes
        field={field}
        form={form}
        childConfig={childConfig}
        assetTypeLength={assetTypeLength}
      />
    </div>
  );
};

const TemplateFields = ({ fields, form, childConfig }) => {
  const [templateFields, setTemplateFields] = useState(fields || false);
  console.log(templateFields);

  useEffect(() => {
    if (templateFields) {
      setTemplateFields(fields);
      console.log('setTemplateFields' , )
    }
  }, [fields]);

  return (
    templateFields &&
    templateFields.length > 0 &&
    templateFields.map(templateField => (
      <TemplateFieldsField
        field={templateField}
        key={templateField.uniqueName}
        form={form}
        childConfig={childConfig}
        assetTypeLength={templateFields.filter(_ => _.type === 'Asset').length}
      />
    ))
  );
};

export default TemplateFields;



// WEBPACK FOOTER //
// ./src/components/NativeTemplates/Helpers/TemplateFields.js